import React from 'react';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import WbCloudyIcon from '@mui/icons-material/WbCloudy';
import CloudIcon from '@mui/icons-material/Cloud';
import GrainIcon from '@mui/icons-material/Grain';
import UmbrellaIcon from '@mui/icons-material/Umbrella';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';

// Buckets the WMO weather codes Open-Meteo returns into a handful of
// conditions we have an icon + i18n label for (`weather.<key>`).
export type WeatherConditionKey =
    | 'clear'
    | 'partlyCloudy'
    | 'cloudy'
    | 'fog'
    | 'drizzle'
    | 'rain'
    | 'snow'
    | 'thunderstorm';

const CODE_MAP: Record<number, WeatherConditionKey> = {
    0: 'clear',
    1: 'clear',
    2: 'partlyCloudy',
    3: 'cloudy',
    45: 'fog',
    48: 'fog',
    51: 'drizzle',
    53: 'drizzle',
    55: 'drizzle',
    56: 'drizzle',
    57: 'drizzle',
    61: 'rain',
    63: 'rain',
    65: 'rain',
    66: 'rain',
    67: 'rain',
    71: 'snow',
    73: 'snow',
    75: 'snow',
    77: 'snow',
    80: 'rain',
    81: 'rain',
    82: 'rain',
    85: 'snow',
    86: 'snow',
    95: 'thunderstorm',
    96: 'thunderstorm',
    99: 'thunderstorm',
};

const ICONS: Record<WeatherConditionKey, React.ComponentType<{ fontSize?: 'small' | 'medium' | 'large'; sx?: object }>> = {
    clear: WbSunnyIcon,
    partlyCloudy: FilterDramaIcon,
    cloudy: WbCloudyIcon,
    fog: CloudIcon,
    drizzle: GrainIcon,
    rain: UmbrellaIcon,
    snow: AcUnitIcon,
    thunderstorm: ThunderstormIcon,
};

export function weatherCondition(code: number | null | undefined): WeatherConditionKey {
    if (code == null) return 'cloudy';
    return CODE_MAP[code] ?? 'cloudy';
}

export function weatherIcon(code: number | null | undefined) {
    return ICONS[weatherCondition(code)];
}
